import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=a27ac174"
var script = {}
import style0 from "./Example.vue?vue&type=style&index=0&id=a27ac174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports